import { DateInput } from "@/shared/components/domain/qpm/inputs/date-input";
import { useCallback, useState } from "react";
import { useDebouncedMutationWithPersistenceStateContextUpdate } from "@/shared/lib/debounce/debounce";
import {
  Offer,
  SetOfferDateRequest,
} from "@/services/backend/qpm/offers/types/offer";
import { useQpmOfferSetDateMutation } from "@/services/backend/qpm/offers/api/offer-api";
import t from "@/lang/lang";
import { useOfferContext } from "@/routes/processes/[processId]/qpm/offers/[offerId]/_components/offer-context";
import {
  fieldErrorsForPrefix,
  resetField,
} from "@/shared/lib/errors/validation-error";

type OfferDateSelectorProps = {
  offer: Offer;
};

export function OfferDateSelector({ offer }: OfferDateSelectorProps) {
  const { validationError, setValidationError } = useOfferContext();
  const fieldErrors = fieldErrorsForPrefix(validationError, "");

  const [request, setRequest] = useState<SetOfferDateRequest>({
    offerId: offer.id,
    date: offer.date,
  });
  const [setDate, { error, isLoading, isSuccess, reset }] =
    useQpmOfferSetDateMutation();

  const onChangeDate = useCallback(
    (date: string | null) => {
      if (date) {
        setValidationError(resetField(validationError, "date"));
        setRequest((prev) => ({ ...prev, date }));
      }
    },
    [setRequest, setValidationError, validationError],
  );

  useDebouncedMutationWithPersistenceStateContextUpdate(
    request,
    setDate,
    isLoading,
    error,
    isSuccess,
    reset,
    500,
    { toastError: true },
  );

  return (
    <DateInput
      label={t("Angebotsdatum")}
      date={request.date}
      onDateChange={onChangeDate}
      disabled={offer.immutable}
      fieldErrors={fieldErrors?.date}
      resetFieldError={() =>
        setValidationError(resetField(validationError, "date"))
      }
    />
  );
}
